import { render, staticRenderFns } from "./UcCompactAccountDisplay.yaml?vue&type=template&id=f94799d4&component"
import script from "./UcCompactAccountDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompactAccountDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports